<template>
    <!-- CN|EN -->
    <div class="select_lang">
        <a :class="[{'active':lang === 'cn'}]" @click="changelang('cn')">中文</a>
        <span></span>
        <a :class="[{'active':lang === 'en'}]" @click="changelang('en')">EN</a>
    </div>
</template>

<script>
    export default {
      data() {
          return {
              lang: 'en', // 全局语言默认选项
          }
      },
      methods:{
        changelang(str){
          sessionStorage.setItem('language',str); // 存入一个值
          this.lang = str
          this.$emit('custom-event')
        },
      },
      mounted(){
        if(sessionStorage.getItem('language')){
          this.lang = sessionStorage.getItem('language'); // 存入一个值
        }else{
          sessionStorage.setItem('language',this.lang); // 存入一个值
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/language.vue